import styled from "@emotion/styled";
import { Box } from "@mui/material";
import React from 'react'

import { gradientBlueBackground } from "themes";
import { SvgIconProps, Typography } from "@mui/material";

interface GradientPageWrapperProps {
  Icon: React.FC<SvgIconProps>;
  title: string;
  children: React.ReactNode;
}

export default function GradientPageWrapper({ Icon, title, children }: GradientPageWrapperProps) {
  return (
    <Container>
      <StyledGradient>
        <TitleContainer>
          <Icon />
          <StyledTitle>{title}</StyledTitle>
        </TitleContainer>
      </StyledGradient>
      {children}
    </Container>
  )
}

const Container = styled(Box)({
  display: "flex",
  width: "100%",
  height: "100%",
  flexDirection: "column",
})

const StyledGradient = styled(Box)({
  background: gradientBlueBackground,
  width: "100%",
  height: "25vh",  
})

const TitleContainer = styled(Box)({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  gap: "1rem",
  color: "white",
  marginTop: "2rem",
  marginLeft: "2rem",
})

const StyledTitle = styled(Typography)({
  fontWeight: 400,
  fontSize: "2rem",
})
